import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { fromFetch } from 'rxjs/fetch';

/**
 * Create a new password reset token and send it in an email to the user
 * @param email user's email
 * @param product Trimble Maps product
 * @param alias account alias (Optional)
 * @param language language to send email
 */
export function postPasswordResetTokenEmail(
  this: unknown,
  request: {
    email: string;
    product: string;
    alias?: string;
    language?: string;
  }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).passwordResetTokenEmailUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify(request),
    })
  ).pipe(ignoreData());
}
